import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Vendor } from '~/features/vendor/types/vendor.type';

/**
 * 벤더 목록 조회
 * @description 전체 벤더 목록을 조회합니다
 * @endpoint GET /admin/vendors
 * @returns 벤더 목록
 */
export function getVendorListApi() {
  return axiosInstance.get<ApiResponse<Vendor[]>>('/admin/vendors');
}
